import { Shippings } from 'stylewhere/api'
import { ShippingOperationConfig } from 'stylewhere/shared'

const ACTION_CODE_RETRIEVE_DISPOSITION = 'RETRIEVE_DISPOSITION'

export interface DispositionResult {
  checklistCode: string | null
  destinationPlaceCode: string | null
}

export const retrieveDisposition = async (
  operation: ShippingOperationConfig,
  productionOrderRowId: string
): Promise<DispositionResult> => {
  return (await Shippings.executeAction(operation, ACTION_CODE_RETRIEVE_DISPOSITION, {
    attributes: { productionOrderRowId }
  })) as DispositionResult
}
